import { type Getter, type Setter } from 'jotai'
import {
  modalDeleteCategoryState,
  defaultModalDeleteCategoryState,
  categoryFormState,
  getDefaultCategoryFormState,
} from '../state/state'
import { loaderUpdater, pageState, statusUpdater } from '../../../state/page'
import { logAppError } from '../../../helpers/logger'
import { checkCategoryUse, deleteCategory } from '../services/services'
import { searchCategories } from './categories'
import { notifyError, notifySuccess } from '../../../helpers/notifyToast'

export const openModalDeleteCategoryCallback = (
  _: Getter,
  set: Setter,
  Id: number,
): void => {
  set(modalDeleteCategoryState, { Id, show: true })
}

export const closeModalDeleteCategoryCallback = (
  _: Getter,
  set: Setter,
): void => {
  set(modalDeleteCategoryState, { ...defaultModalDeleteCategoryState })
}

export const submitModalDeleteCategoryCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  set(pageState, loaderUpdater(true))
  try {
    const { Id } = get(modalDeleteCategoryState)
    const containsFiltersResponse = await checkCategoryUse(Id)
    if (containsFiltersResponse.length > 0) {
      notifyError('Load.Filters.MsgNoCancCat')
    } else {
      await deleteCategory(Id)
      await searchCategories(get, set)
      notifySuccess('Load.Alerts.SuccessDelete')
      set(categoryFormState, getDefaultCategoryFormState())
    }
  } catch (error: any) {
    console.error('### error', error)
    logAppError({
      Component: 'newCategoriesListPage',
      Method: 'submitModalDeleteCategoryCallback',
      appError: error,
    })
    set(pageState, statusUpdater('error'))
  }
  set(pageState, loaderUpdater(false))
  set(modalDeleteCategoryState, { ...defaultModalDeleteCategoryState })
}
